var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Titlebar'),_c('EventForm',{attrs:{"busy":_vm.submitting},on:{"submit":_vm.onSubmit},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }